import React from "react";
import { connect } from "react-redux";
import type { Dispatch } from "redux";
import Select from "react-select";

import { RESET_FILTERS } from "@/modules/pg/shared/planningTable/reducers/filters/filters";
import { translate } from "@/modules/shared/IntlProviderWrapper";

import { ReduxFilters } from "@/modules/pg/shared/planningTable/reducers/logic/businessLogic";

import type {
    SetRescheduleOrderAction,
    SetRescheduleOrderBundleAction,
} from "@/modules/pg/shared/planningTable/reducers/common";
import type {
    SetHighlightedOrders,
    SetLastClickedOrderUuid,
} from "@/modules/pg/shared/planningTable/reducers/planningTable";
import type { SelectOptionItem } from "@/modules/shared/planningTable/typeFilterConsts";
import type { ReduxState } from "@/modules/pg/shared/planningTable/reducers/reducers";
import type { ResetFiltersAction } from "@/modules/pg/shared/planningTable/reducers/filters/filters";

type ActionTypes =
    | SetRescheduleOrderAction
    | ResetFiltersAction
    | SetHighlightedOrders
    | SetLastClickedOrderUuid
    | SetRescheduleOrderBundleAction;
type OwnProps = {};
type Props = OwnProps & ReduxProps;

class RescheduleOperationFilter extends React.Component<Props> {
    onChange = (option: SelectOptionItem) => {
        if (!option) {
            this.props.reduxDispatch({ type: RESET_FILTERS, data: undefined });
        } else {
            ReduxFilters.setRescheduleOrderUuid(
                this.props.reduxDispatch,
                option.value,
                "line_order_list",
                this.props.is_filter_locked
            );
        }
    };

    getSelectedOptions = (): SelectOptionItem | null => {
        if (!this.props.reschedule_order_uuid) {
            return null;
        }
        for (const line_order of this.props.orders) {
            for (const order of line_order.orders) {
                if (order.uuid === this.props.reschedule_order_uuid) {
                    return {
                        value: this.props.reschedule_order_uuid,
                        label: order.external_id + " - " + order.process_num,
                    };
                }
            }
        }
        return null;
    };

    getOptions = (): SelectOptionItem[] => {
        const options: SelectOptionItem[] = [];
        for (const line_order of this.props.orders) {
            for (const order of line_order.orders) {
                options.push({
                    value: order.uuid,
                    label: order.external_id + " - " + order.process_num,
                });
            }
        }
        return options;
    };

    render() {
        return (
            <div className="order-filter">
                <Select
                    value={this.getSelectedOptions()}
                    placeholder={translate("common.operation", "Operation")}
                    options={this.getOptions()}
                    onChange={this.onChange}
                    isSearchable={true}
                    isClearable
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 100 }),
                        menu: base => ({ ...base, width: "max-content", minWidth: "100%" }),
                    }}
                />
            </div>
        );
    }
}

const mapState = (state: ReduxState) => {
    const orders = state.gantt_chart_lines_orders.lines_orders.concat(
        state.gantt_chart_lines_orders.unscheduled_orders
    );

    return {
        reschedule_order_uuid: state.gantt_chart_filters.reschedule_order_uuid,
        orders,
        is_filter_locked: state.gantt_chart_filters.is_filter_locked,
    };
};
const mapDispatch = (dispatch: Dispatch<ActionTypes>) => ({
    reduxDispatch: dispatch,
});

type ReduxProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
export default connect<ReturnType<typeof mapState>, ReturnType<typeof mapDispatch>, OwnProps, ReduxState>(
    mapState,
    mapDispatch
)(RescheduleOperationFilter);
